import type { Coupon, CouponStatus } from '../../../../schema/coupon/entry.js';
import type { Definition } from '../../../../schema/frameworks/entry.js';
import { calculatePrice } from './calculatePrice.js';
import { getEventCount } from './getEventCount.js';
import { selectSystemSize } from './selectSystemSize.js';

type QueryOptionsType = {
  definition: Definition;
};

/**
 * Selects the status of a given coupon.
 * Will return the VALID if the coupon is considered payable. Otherwise, it will return a specific validation status.
 *
 * @param coupon Coupon entity
 * @param root0 Object containing query options
 * @param root0.definition Product definition
 * @returns Current coupon status for given coupon id
 */
export function getCouponStatus(coupon: Coupon, { definition }: QueryOptionsType): CouponStatus {
  if (coupon.couponType === 'external_system') {
    return 'VALID';
  }

  let numCompleteRows = 0;
  let hasIncompleteRow = false;
  /* const productId = coupon?.productId;
    const drawNumber = coupon?.drawNumber;
    const draw = selectDraw(state, productId, drawNumber); */
  const price = calculatePrice(coupon, { definition });
  const isMultiBoard = coupon.boards.length > 1;
  const { minStake, maxSystemSize } = definition;

  for (const board of coupon.boards) {
    const systemSize = selectSystemSize(board, { definition });
    // const selectedSystemType = selectSystemType(state, couponId);
    if (/* selectedSystemType === SYSTEM_MSYS */ maxSystemSize && systemSize > maxSystemSize) {
      return 'INVALID_MAX_SIZE_EXCEEDED';
    }

    const { maxStake } = definition;
    if (/* selectedSystemType === SYSTEM_MSYS */ maxStake && price > maxStake) {
      return 'INVALID_MAX_SIZE_EXCEEDED';
    }

    const [startedEventCount, totalEventCount] = getEventCount(board);
    const isBoardComplete = startedEventCount === totalEventCount;
    if (isMultiBoard) {
      if (isBoardComplete) {
        numCompleteRows += 1;
        continue;
      }

      hasIncompleteRow = true;
      continue;
    }

    if (startedEventCount === 0) {
      return 'INVALID_NOT_STARTED';
    }

    if (!isBoardComplete) {
      return 'INVALID_NO_COMPLETE_BOARD';
    }

    /* let systemStatus;
      if (selectedSystemType === SYSTEM_REDUCERA_FRITT) {
        systemStatus = getReduceModeStatus(state, couponId, boardIndex);
      } else if (
        selectedSystemType === SYSTEM_RSYS ||
        selectedSystemType === SYSTEM_USYS
      ) {
        systemStatus = getSystemStatus(state, couponId, boardIndex);
      }

      if (systemStatus) { // didnt get a bad reply(undefined) from previous checks so please continue
        return systemStatus;
      }

      const numberOfEvents = selectOutcomes(state, couponId, boardIndex).length;

      // Go through every event and check if any reduction has been done that leads to 0 rows in a combination
      for (let eventNumber = 1; eventNumber <= numberOfEvents; eventNumber++) {
        if (
          selectIsEventReduced(state, couponId, eventNumber, boardIndex) &&
          !selectSROWForEvent(state, couponId, eventNumber, boardIndex).length) {
          return COUPON_INVALID_ZERO_ROWS_REDUCTION;
        }
      } */
  }

  // replicates the validation behavior of todays tipset with multiple boards for single rows
  // it's OK to have multiple incomplete boards when at least one complete board exists.
  if (hasIncompleteRow && numCompleteRows === 0) {
    return 'INVALID_NOT_STARTED';
  }

  /* const wallet = selectActiveWallet(state);
    const { minGroupAmount } = selectEngineDefinition(state);
    if (
      wallet?.type === WALLET_MARKETPLACE_RETAILER &&
      price < minGroupAmount
    ) {
      return COUPON_INVALID_BELOW_GROUP_AMOUNT;
    } */

  if (price < minStake) {
    return 'INVALID_PRICE_IS_LOWER_THAN_MINSTAKE';
  }

  /* const shouldIgnoreCompetition = draw && draw.isLite;
    const activeCompetitionId = selectActiveCompetitionId(state);
    const competitionDetails = selectCompetitionDetails(state, activeCompetitionId);
    if (competitionDetails && !shouldIgnoreCompetition) {
      // Override used for addon product that is not used in competition
      const sysType = competitionDetails.systemType;
      if (sysType === SYSTEM_MSYS) {
        const systemSize = selectSystemSize(state, couponId, 0);
        if (systemSize !== competitionDetails.systemNumber) {
          return COUPON_DONT_MATCH_COMPETITION_SYSTEMSIZE;
        }
      } else if (sysType === SYSTEM_RSYS) {
        return COUPON_DONT_MATCH_COMPETITION_SYSTEMSIZE;
      } else if (sysType === SYSTEM_USYS) {
        return COUPON_DONT_MATCH_COMPETITION_SYSTEMSIZE;
      }
    } */

  return 'VALID';
}
